import { Api, Toast } from './../../../services'

export default {
  name: 'projectItem',
  props: [],
  data() {
    return { 
      sumGGC: 0,
      sumGCC: 0,
      affiliate: false,    
    }
  },    
  props: {
    project: {
      type: Object,
      default() {
        return {
          public: false,
          ggc: 0,
          userEmail: "",
          userOwner: "",
        }
      },
    },
    displayEditButton: {
      type: Boolean,
      default: false,
    }, 
  },
  methods: {
    goToDetails: function() { 
      this.$localStorage.set('GGC', this.project.sumGGC)
      this.$localStorage.set('GCC', this.project.sumGCC)
      window.location.href =
        '/project/systemsdetail/existing/' + this.project._id

    },
    getGGC(nameplateCapacity, capacitySize) {           
      if ( nameplateCapacity == undefined || nameplateCapacity == 'off' || nameplateCapacity == '0' || nameplateCapacity == '') return 0;
      var ggc = 0
      if (capacitySize == 'KW') {
          nameplateCapacity = parseFloat(nameplateCapacity)/1000
      }
      ggc = nameplateCapacity/12

      return ggc.toFixed(4)
    },  
    getGreen(owner, id) {
      $('.modal').modal('show');
      this.$refs.owner = owner;
      
      setTimeout(() => {console.log("in set timeout *************"); $('#prjId').val(id); $('#prjOwner').val(owner);}, 1500);      
    },

    async sendInfo(id) {
      try {
        var response = await Api.sendInfoProject(id)

        Toast.success({
            toast: this.$toast,
            message: "Project's info successfully sent on your email",
        })

      } catch (error) {
        console.log(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: 'Something went wrong.',
        })
      } finally {
      }
    }
    
  },
  async created() {
    // this.ggc = this.getGGC(this.project.nameplateCapacity, this.project.capacitySize)

    this.userEmail = this.$localStorage.get("userEmail")
    this.userOwner = (this.project.owner) ? (JSON.parse(this.project.owner)).email : ""

    var logos = {0:"solar", 1:"wind", 2:"gas", 3:"hydro"}, typeForLogo = "";          
    for (var key in logos){           
      typeForLogo = this.project.type.toLowerCase()           
      if (typeForLogo.indexOf(logos[key])>-1) this.project.typeLogo = '/static/dist/images/' + logos[key] + '.svg';
    }

    jQuery(document).ready(function($) {
      var items = document.querySelectorAll(
        '.item-block .cmb-txt h4, .item-block .cmb-txt div'
      )
      for (var i = 0; i < items.length; i++) {
        $clamp(items[i], { clamp: 3 })
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectItem/ProjectItem.component.js